export default (id) => {

  let name = ""

  if (id == "01") {
    name = "Itu"
  } else if (id == "02") {
    name = "Três Lagoas"
  }

  return name
}